import React from "react"
import {FieldAutomationActionFormProps} from "../../../render/automation-action-form";
import FieldFormElementView from "../../../render/form-elemnent-view";

export default class FieldProto_AutomationActionForm extends React.Component<FieldAutomationActionFormProps> {

    onChangeToValue     = (option:any)  => {
        const toValue = option ? option.value : null
        this.props.onChangeCallback({toValue})
    }

    render() {

        const model = {
            [this.props.field.fieldId]: this.props.config.toValue
        }

        return (
            <div className="flex-row-left-top">
                <div className="label">to</div>

                <FieldFormElementView field={this.props.field}
                                      model={model}
                                      onChange={(value)=>{this.onChangeToValue({value})}}
                                      className="w-180"
                                      disabled={this.props.config.disabled} />

            </div>
        )
    }
}